export * from './PointTextTmpl'
